module.exports = __webpack_public_path__ + "img/help_register_x@3x.92b023e7.png";